import * as React from "react";
import { createStyles, Grid, Theme, withStyles } from "@material-ui/core";
import Logo from "./Logo";
import {Auth} from "aws-amplify";
import {useEffect} from "react";

const styles = ({ spacing }: Theme) =>
  createStyles({
    root: {
      flexGrow: 1,
      marginLeft: spacing(16),
      marginRight: spacing(16),
    },
  });

const Page: React.FC = (props: any) => {
  const { classes } = props;

  useEffect(() => {

    Auth.federatedSignIn({
      customProvider: 'FederateOIDC'
    }).then(() => {
      console.log("Federate successful");
    }).catch((e) => {
      console.log(`Federate unsuccessful with error: ${e}`)
      window.location.href = '/error';
    });
  }, []);

  return (
    <div className={classes.root}>
      <Grid container spacing={10} justifyContent="center" alignItems="stretch">
        <Logo />
      </Grid>
    </div>
  );
};

export default withStyles(styles)(Page);
